__turbopack_context__.v({
  "blockTestimonial": "BlockTestimonial-module-scss-module__NA_eeG__blockTestimonial",
  "blockTestimonialInner": "BlockTestimonial-module-scss-module__NA_eeG__blockTestimonialInner",
  "blueBackground": "BlockTestimonial-module-scss-module__NA_eeG__blueBackground",
  "flushTop": "BlockTestimonial-module-scss-module__NA_eeG__flushTop",
  "whiteBackground": "BlockTestimonial-module-scss-module__NA_eeG__whiteBackground",
});
